import Vue from 'vue';
import Router from 'vue-router';
import Startup from '@/components/Startup';
import Race from '@/components/Race';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Startup',
      component: Startup
    },
    {
      path: '/race',
      name: 'Race',
      component: Race
    }
  ],
  props: [
    'infomessage'
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js